import { call, put } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

export function* postDnataFormSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield call(Api.postDnataForm, formName, formContent);
  } catch (error) {
    yield put(actions.addError("post-dnata-form", error));
  }
}

export function* submitDnataOnboardingSaga({ payload }) {
  try {
    const { dnataContent } = payload;
    yield call(Api.submitDnataForm, dnataContent);
    yield put(actions.dnataOnboardingSubmitted());
  } catch (error) {
    yield put(actions.addError("dnata-form-submit", error));
  }
}

export function* submitDnataTestSaga({ payload }) {
  yield put(actions.setDnataTestLoading(true));
  try {
    const { testAnswers } = payload;
    const response = yield call(Api.submitDnataTest, testAnswers);
    yield put(actions.dnataTestSubmitted(response.data.result));
    yield put(actions.setDnataTestLoading(false));
  } catch (error) {
    yield put(actions.addError("dnata-test-submit", error));
    yield put(actions.setDnataTestLoading(false));
  }
}

export function* submitDnataExtraFormSaga({ payload }) {
  try {
    const { formName, formContent } = payload;
    yield put(actions.setDnataExtraFormLoading(formName));
    yield call(Api.submitDnataExtraForm, formName, formContent);
  } catch (error) {
    yield put(actions.addError("submit-dnata-additional-form", error));
    yield put(actions.setDnataExtraFormLoading(""));
  }
  yield put(actions.setDnataExtraFormLoading(""));
}
